export default __webpack_public_path__ + "static/media/inputDateIcon.670a78d2.svg";